import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import React from "react";
import { asyncInputEvent } from "./handler-wrapper";

var SearchInputCore = function SearchInputCore(_ref, ref) {
  var _ref$placeholder = _ref.placeholder,
      placeholder = _ref$placeholder === void 0 ? "PlaceHolder" : _ref$placeholder,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? "text" : _ref$type,
      _ref$initialValue = _ref.initialValue,
      initialValue = _ref$initialValue === void 0 ? "" : _ref$initialValue,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className,
      _ref$debounceTime = _ref.debounceTime,
      debounceTime = _ref$debounceTime === void 0 ? 400 : _ref$debounceTime,
      _ref$getInputValueSet = _ref.getInputValueSetter,
      getInputValueSetter = _ref$getInputValueSet === void 0 ? function () {} : _ref$getInputValueSet,
      _ref$onClick = _ref.onClick,
      _onClick = _ref$onClick === void 0 ? function () {} : _ref$onClick,
      _ref$onDoubleClick = _ref.onDoubleClick,
      _onDoubleClick = _ref$onDoubleClick === void 0 ? function () {} : _ref$onDoubleClick,
      _ref$onMouseDown = _ref.onMouseDown,
      _onMouseDown = _ref$onMouseDown === void 0 ? function () {} : _ref$onMouseDown,
      _ref$onMouseEnter = _ref.onMouseEnter,
      _onMouseEnter = _ref$onMouseEnter === void 0 ? function () {} : _ref$onMouseEnter,
      _ref$onMouseLeave = _ref.onMouseLeave,
      _onMouseLeave = _ref$onMouseLeave === void 0 ? function () {} : _ref$onMouseLeave,
      _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === void 0 ? function () {} : _ref$onChange,
      _ref$onChangeAsync = _ref.onChangeAsync,
      onChangeAsync = _ref$onChangeAsync === void 0 ? function () {} : _ref$onChangeAsync,
      _ref$onFocus = _ref.onFocus,
      _onFocus = _ref$onFocus === void 0 ? function () {} : _ref$onFocus,
      _ref$onBlur = _ref.onBlur,
      _onBlur = _ref$onBlur === void 0 ? function () {} : _ref$onBlur,
      _ref$onKeyUp = _ref.onKeyUp,
      _onKeyUp = _ref$onKeyUp === void 0 ? function () {} : _ref$onKeyUp,
      _ref$onKeyDown = _ref.onKeyDown,
      _onKeyDown = _ref$onKeyDown === void 0 ? function () {} : _ref$onKeyDown,
      _ref$onKeyPress = _ref.onKeyPress,
      _onKeyPress = _ref$onKeyPress === void 0 ? function () {} : _ref$onKeyPress,
      _ref$onSubmit = _ref.onSubmit,
      _onSubmit = _ref$onSubmit === void 0 ? function () {} : _ref$onSubmit,
      _ref$tabIndex = _ref.tabIndex,
      tabIndex = _ref$tabIndex === void 0 ? 0 : _ref$tabIndex;

  var _React$useState = React.useState(initialValue),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      value = _React$useState2[0],
      setValue = _React$useState2[1];

  var handlerDefaults = React.useCallback(function (e, cb) {
    // e.preventDefault();
    // e.stopPropagation();
    cb(e);
  }, []);
  var inputHandlers = React.useCallback(asyncInputEvent(function (e) {
    e.preventDefault();
    e.stopPropagation();
    onChangeAsync(e);
  }, function (e) {
    e.preventDefault();
    e.stopPropagation();
    setValue(e.target.value);
    onChange(e);
  }, debounceTime), [setValue]);
  React.useLayoutEffect(function () {
    getInputValueSetter(setValue);
  });
  return React.createElement("input", {
    tabIndex: tabIndex,
    ref: ref,
    type: type,
    name: "SearchInput",
    value: value,
    placeholder: placeholder,
    className: "search-input".concat(className ? " ".concat(className) : ""),
    onClick: function onClick(e) {
      return handlerDefaults(e, _onClick);
    },
    onDoubleClick: function onDoubleClick(e) {
      return handlerDefaults(e, _onDoubleClick);
    },
    onMouseEnter: function onMouseEnter(e) {
      return handlerDefaults(e, _onMouseEnter);
    },
    onMouseLeave: function onMouseLeave(e) {
      return handlerDefaults(e, _onMouseLeave);
    },
    onMouseDown: function onMouseDown(e) {
      return handlerDefaults(e, _onMouseDown);
    },
    onChange: inputHandlers,
    onFocus: function onFocus(e) {
      return handlerDefaults(e, _onFocus);
    },
    onBlur: function onBlur(e) {
      return handlerDefaults(e, _onBlur);
    },
    onKeyUp: function onKeyUp(e) {
      return handlerDefaults(e, _onKeyUp);
    },
    onKeyDown: function onKeyDown(e) {
      return handlerDefaults(e, _onKeyDown);
    },
    onKeyPress: function onKeyPress(e) {
      return handlerDefaults(e, _onKeyPress);
    },
    onSubmit: function onSubmit(e) {
      return handlerDefaults(e, _onSubmit);
    }
  });
};

var SearchInput = React.forwardRef(SearchInputCore);

function SearchInputWrapper() {
  var _React$useState3 = React.useState("hebele"),
      _React$useState4 = _slicedToArray(_React$useState3, 1),
      state
  /*setState*/
  = _React$useState4[0];

  var inputValueSetter = React.useRef(function () {});
  setTimeout(function () {
    // setState('deneme');
    inputValueSetter.current("deneme");
  }, 5000);
  return React.createElement(SearchInput, {
    initialValue: state,
    getInputValueSetter: function getInputValueSetter(fn) {
      return inputValueSetter.current = fn;
    },
    onClick: function onClick(e) {// console.log("[CLICK]", "input clicked");
    },
    onDoubleClick: function onDoubleClick(e) {// console.log("[DOUBLECLICK]", "input double clicked");
    }
  });
}

export { SearchInputWrapper, SearchInput };